import React from 'react'

import { SmallText, Title } from '../../../components/presentation/Text'
import { useServiceOrder } from './_load/ServiceOrderLoader'
import EditServiceOrdersUserForm from './EditServiceOrdersUserForm'
import Separator from '../../../components/helpers/Separator'

const Details = () => {
  const serviceOrder = useServiceOrder()

  return (
    <>
      <SmallText>{serviceOrder.yearlyId}</SmallText>
      <Title size="h5">Alterando usuário</Title>
      <Separator weight={6} />
      <EditServiceOrdersUserForm />
    </>
  )
}

export default Details
